// extracted by mini-css-extract-plugin
export var option = "_3y-0";
export var optionCard = "_3y-f";
export var optionContent = "_3y-g";
export var optionIcon = "_3y-i";
export var optionIconBox = "_3y-h";
export var optionLabel = "_3y-j";
export var optionPill = "_3y-m";
export var optionPillBadge = "_3y-p";
export var optionPillIcon = "_3y-n";
export var optionPillLabel = "_3y-o";
export var optionRadio = "_3y-k";
export var optionRadioInner = "_3y-l";
export var optionReveal = "_3y-2";
export var optionRevealDelay0 = "_3y-3";
export var optionRevealDelay1 = "_3y-4";
export var optionRevealDelay10 = "_3y-d";
export var optionRevealDelay11 = "_3y-e";
export var optionRevealDelay2 = "_3y-5";
export var optionRevealDelay3 = "_3y-6";
export var optionRevealDelay4 = "_3y-7";
export var optionRevealDelay5 = "_3y-8";
export var optionRevealDelay6 = "_3y-9";
export var optionRevealDelay7 = "_3y-a";
export var optionRevealDelay8 = "_3y-b";
export var optionRevealDelay9 = "_3y-c";
export var optionSelected = "_3y-1";